export default __webpack_public_path__ + "static/media/menu-play.e108aa32.jpg";